import React from 'react';
import { useParams } from 'react-router-dom';
import { CatalogForm } from '../../../components/CatalogForm/CatalogForm';
import { EmbalajeGrupoService } from '../../../services/EmbalajeGrupoService';
import { Validators } from '../../../components/CatalogForm/validators';

const formFields = [
  {
    name: 'grupo',
    label: 'Nombre del Grupo',
    type: 'text',
    col: 12,
    placeholder: 'Ej. Cajas de Cartón',
    validators: [
      Validators.required("El nombre del grupo es obligatorio")
    ],
  },
];

export const EmbalajeGrupoForm = () => {
  const { id } = useParams();

  const handleLoadData = async (recordId) => {
    return await EmbalajeGrupoService.obtenerPorId(recordId);
  };

  const handleSubmit = async (values) => {
    return await EmbalajeGrupoService.guardar(values);
  };

  return (
    <CatalogForm
      title="Grupo de Embalaje"
      subtitle="Agrupación y clasificación de tipos de embalajes"
      fields={formFields}
      id={id}
      loadData={handleLoadData}
      onSubmit={handleSubmit}
      backUrl="/Catalogo/GruposEmbalajes"
    />
  );
};

export default EmbalajeGrupoForm;
